import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FileUploader, FileItem, FileUploaderOptions, Headers } from 'ng2-file-upload';
import { formatBytesString } from '../../../functions/string.helpers';

export const mimeTypeExtensions = [
  { type: 'application/pdf', extension: 'pdf'},
  { type: 'text/csv', extension: 'csv'},
  { type: 'application/msword', extension: 'doc'},
  { type: 'image/*', extension: 'imagen'}
];

@Component({
  selector: 'siu-drag-drop-single-uploader',
  templateUrl: './drag-drop-single-uploader.component.html',
  styleUrls: [ './drag-drop-single-uploader.component.scss' ]
})
export class DragDropSingleUploaderComponent implements OnInit, OnChanges {

  @Input() url: string;

  @Input() fileItem: FileItem;

  uploader: FileUploader;

  hasBaseDropZoneOver: boolean = false;

  @Output('on-change') onChangeEvent: EventEmitter<FileItem> = new EventEmitter();

  @Input('upload-headers') headers: Headers[];

  @Input() allowedMimeType: string[];

  @Input() maxFileSize: number;

  @Output() onWhenAddingFileFailed: EventEmitter<string> = new EventEmitter();

  constructor() {

  }

  ngOnInit() {

    let options: FileUploaderOptions = {};
    options.url = this.url;
    if (this.headers) options.headers = this.headers;
    if (this.allowedMimeType) options.allowedMimeType = this.allowedMimeType;
    if (this.maxFileSize) options.maxFileSize = this.maxFileSize;

    this.uploader = new FileUploader(options);
    //this.uploader.onAfterAddingFile = (file) => { file.withCredentials = false; };
    this.uploader.onWhenAddingFileFailed = (item, filter) => {
      let message = '';
      switch (filter.name) {
        case 'mimeType':
          message = `Sólo se permite archivos en formato ${this.allowedMimeType.map((i) => (mimeTypeExtensions.find(x => x.type === i) || { extension: i }).extension).join(', ')}`;
          break;
        case 'fileSize':
          message = `El archivo ${item.name} (${formatBytesString(item.size)}) excede el tamaño permitido (${formatBytesString(this.maxFileSize)})`;
          break;
        default:
          message = `Error al adjuntar el archivo ${item.name}`;
          break;
      }
      this.onWhenAddingFileFailed.emit(message);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.fileItem) {
      if (!changes.fileItem.currentValue && this.uploader) {
        this.uploader.clearQueue();
      }
    }
  }

  fileOverBase = (e) => {
    this.hasBaseDropZoneOver = e;
  }

  handleClickDelete = () => {
    this.uploader.clearQueue();
    this.onChangeEvent.emit(null);
  }

  handleDropped = (e) => {
    this.onChangeEvent.emit(this.uploader.queue[ 0 ]);
  }

  handleChangeInputFile = () => {
    this.onChangeEvent.emit(this.uploader.queue[ 0 ]);
  }

}
